module.exports = __webpack_public_path__ + "static/images/cover_C16.9b994f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C16.png
// module id = 7QTM
// module chunks = 8